// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class Constants {
}
Constants.keys = {
    tab: "Tab",
    enter: "Enter",
    escape: "Escape",
    space: " ",
    up: "ArrowUp",
    down: "ArrowDown",
    delete: "Delete"
};
//# sourceMappingURL=constants.js.map